import { ui, UIViewType, UIViewState } from "./state";

const { actions } = ui;

export const uiActions = {
  ...actions,

  // Notifications
  showError(message = "There was an error processing your request.") {
    return actions.showNotification({ message, variant: "error" });
  },

  showMessage(message: string) {
    return actions.showNotification({ message });
  },

  showSuccess(message: string) {
    return actions.showNotification({ message, variant: "success" });
  },

  // Views
  /** Dynamically creates an action function which sets `view[name] = false`. */
  toHideView(name: keyof UIViewState) {
    return () => actions.setView({ [name]: false });
  },
  /** Dynamically creates an action function which removes `view[name]`. */
  toRemoveView(name: keyof UIViewState) {
    return () => actions.setView({ [name]: undefined });
  },
  /** Dynamically creates an action function which sets `view[name] = value`. */
  toSetView(name: keyof UIViewState) {
    return (value?: UIViewType) => actions.setView({ [name]: value });
  },
  /** Dynamically creates an action function which sets `view[name] = true`. */
  toShowView(name: keyof UIViewState) {
    return () => actions.setView({ [name]: true });
  },

  // Modals
  openUploadModal(row) {
    return actions.triggerUploadModal({ open: true, row });
  },
  closeUploadModal() {
    return actions.triggerUploadModal({ open: false });
  },
  openBundleSuccessModal(bundle) {
    return actions.showBundlesSuccessModal({ open: true, bundle });
  },
  closeBundleSuccessModal() {
    return actions.showBundlesSuccessModal({ open: false });
  },
};
